// Vendor
import * as React from 'react';
import Img from 'gatsby-image';
import { graphql, useStaticQuery } from 'gatsby';

interface ImageProps {
  addLink?: boolean;
  alt: string;
  className?: string;
  fileName: string;
  maxWidth?: number;
}

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

/**
 * Why get all images? https://noahgilmore.com/blog/easy-gatsby-image-components/
 */

const Image: React.FC<ImageProps> = (props) => {
  const { addLink, alt, className, fileName, maxWidth } = props;

  const data = useStaticQuery(graphql`
    query {
      images: allFile {
        edges {
          node {
            relativePath
            name
            childImageSharp {
              fluid(maxWidth: 1200, quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `);

  const image = data.images.edges.find((n: GatsbyTypes.FileEdge) => {
    return n.node.relativePath.includes(`images/${fileName}`);
  });

  if (!image) return null;

  const style = maxWidth ? { maxWidth } : {};

  if (addLink) {
    return (
      <a
        href={image.node.childImageSharp.fluid.src}
        rel="noopener noreferrer"
        target="_blank"
      >
        <Img
          alt={alt}
          className={className}
          fluid={image.node.childImageSharp.fluid}
          style={style}
        />
      </a>
    );
  }

  return (
    <Img
      alt={alt}
      className={className}
      fluid={image.node.childImageSharp.fluid}
      style={style}
    />
  );
};

export { Image };
